<template>
	<div style="height:100%;position: relative;">
		<div class="flex-title">
			<div class="nickname">{{cousultNickName}}</div>
			<div class="flex-time" v-show="assemblyType=='1' && ConsultId!=''">
				当前会话时长：
				<span class>
					<showTime :isStarts="autoStarts" :countVals="entryTimeMillisecond"></showTime>
				</span>
			</div>
			<div v-show="assemblyType =='1'&& ConsultId!=''">
				<a class="Transfer" @click.stop="transfer">转接</a>
				<a class="ended" @click="dialogVisible=true">结束服务</a>
			</div>
		</div>
		<div class="search-box">
			<el-input placeholder="搜索聊天内容" v-model="input11">
				<el-button slot="append" icon="el-icon-search" @click="chatBoxSearch"></el-button>
			</el-input>
		</div>
		<div class="talk" id="testDiv">
			<div class="container">
				<p v-if="ConsultId!='' && noMoreVisbile==false">
					<a @click="getChatRecord">
						<i class="el-icon-alarm-clock"></i>查看更多消息
					</a>
				</p>
				<p v-if="noMoreVisbile">没有更多了</p>
				<p v-if="loading">加载中...</p>
				<p
					v-if="(Dialogues1==undefined || Dialogues1.length==0) && loading===false && paginations.pageIndex>0 && ConsultId!=''"
				>暂无消息记录</p>
				<p v-show="assemblyType=='1' && ConsultId !=''">{{getTimeVal()}} 用户接入</p>
				<!-- <div class v-for="(item,index) in Dialogues">
					<div class="niming">{{item.sendNickName!=undefined?item.sendNickName:kfNickName}}</div>
					<div :class="item.dialogues[0].sender==2?'talk_right':'talk_left'">		
					</div>
				</div>-->
				<div class :key="index" v-for="(item,index) in Dialogues1">
					<div class="niming" v-if="item.dialogues[0].sender==1">{{consultNickName}}</div>
					<div
						class="niming"
						v-if="item.dialogues[0].sender==2"
						style="text-align: right;"
					>{{item.sendNickName!=undefined?item.sendNickName:kfNickName}}</div>
					<div v-if="item.dialogues[0].sender==2" class="talk_right">
						<div style="width:20px;height:20px;margin-right:10px;">
							<!-- <i class="el-icon-loading" style="font-size:20px;" v-if="item.isSuccess=='正在发送'" /> -->
							<el-tooltip
								class="item"
								effect="dark"
								v-show="item.isSuccess==3001"
								content="正在发送"
								placement="top-start"
							>
								<img
									src="https://corpcswechatstaging.nestlechinese.com/img/miniSys/5-121204193R0.gif"
									style="width:100%;height:100%"
									v-show="item.isSuccess==3001"
								/>
							</el-tooltip>
							<el-tooltip
								class="item"
								effect="dark"
								v-show="item.isSuccess==3005"
								:content="errSendMsgMessage"
								placement="top-start"
							>
								<img
									src="https://corpcswechatstaging.nestlechinese.com/img/miniSys/tan01.png"
									style="width:100%;height:100%;"
									v-show="item.isSuccess==3005 "
									@click="ResendMessage(item)"
									id="errorImg"
								/>
							</el-tooltip>
						</div>
						<div class="content">
							<div class="text">
								<span :key="index" v-for="(items,index) in item.dialogues" v-if="items.messageType!==10">
									<img v-if="items.messageType===2" :src="items.content" v-image-preview />
									<video v-else-if="items.messageType===3" :src="items.content" controls="controls"></video>
									<a v-else-if="items.messageType===6" :href="items.content">{{items.content}}</a>
									<p v-else-if="items.messageType===12" id="rowText">{{items.content}}</p>
									<p v-else-if="items.messageType===13" style="border-bottom:1px dashed #ccc;margin:10px 0;"></p>
									<span v-else>{{items.content}}</span>
								</span>
							</div>
							<div class="itemTime">{{getTimeVal(item.sendTime)}}</div>
						</div>
						<div class="heading" v-if="item.dialogues[0].sender==2">
							<!-- <img :src="item.sendHeadimg==undefined?kfDefaultHeadimg:item.sendHeadimg" /> -->
							<el-avatar
								shape="square"
								:src="item.sendHeadimg==undefined?kfDefaultHeadimg:item.sendHeadimg"
							></el-avatar>
						</div>
					</div>
					<div v-if="item.dialogues[0].sender==1" class="talk_left">
						<div class="heading" v-if="item.dialogues[0].sender==1">
							<!-- <img :src="consultDefaultHeadimg" /> -->
							<el-avatar shape="square" :src="consultDefaultHeadimg"></el-avatar>
						</div>
						<div class="content">
							<div class="text">
								<span :key="index" v-for="(items,index) in item.dialogues" v-if="items.messageType!==10">
									<img v-if="items.messageType===2" :src="items.content" v-image-preview />
									<video v-else-if="items.messageType===3" :src="items.content" controls="controls"></video>
									<a v-else-if="items.messageType===6" :href="items.content">{{items.content}}</a>
									<p v-else-if="items.messageType===12" id="rowText">{{items.content}}</p>
									<p v-else-if="items.messageType===13" style="border-bottom:1px dashed #ccc;margin:10px 0;"></p>
									<span v-else>{{items.content}}</span>
								</span>
							</div>
							<span class="itemTime">{{getTimeVal(item.sendTime)}}</span>
							<div v-if="addressMonitoringShow(item.dialogues)" class="addressMonitoring">
								<el-tooltip class="item" effect="dark" content="写入用户信息" placement="top-start">
									<i class="el-icon-edit-outline" @click="saveAddressMonitorting(item.dialogues)"></i>
								</el-tooltip>
							</div>
						</div>
					</div>
					<div v-if="item.dialogues[0].sender==3">
						<p>
							{{getTimeVal(item.transferList[0].createTime)}}
							会话转接至 {{item.transferList[1].nickName}}
						</p>
						<p>备注：{{(item.transferList[0].reamarks!='' && item.transferList[0].reamarks!=undefined)?item.transferList[0].reamarks:'无'}}</p>
						<el-divider>以上为历史消息</el-divider>
						<p>
							{{getTimeVal(item.transferList[0].createTime)}}
							已收到来自 {{item.transferList[0].nickName}} 转接的会话
						</p>
						<p>备注：{{(item.transferList[0].reamarks!='' && item.transferList[0].reamarks!=undefined)?item.transferList[0].reamarks:'无'}}</p>
					</div>
				</div>
			</div>
			<!-- <div class="remarks" v-show="TransferRemarks!=='' && TransferRemarks">
				<span>转单备注:</span>
				<br />
				{{TransferRemarks}}
			</div>-->
		</div>
		<div class="tool1">
			<div v-show="assemblyType!=='3'" class="tool">
				<div class="emoji_box">
					<el-tooltip class="item" effect="dark" content="表情" placement="top-start">
						<i class="iconfont icon-biaoqing" @click.stop="show4=!show4"></i>
					</el-tooltip>
					<div class="emoji" v-if="show4">
						<div
							class="el-tabs__content"
							v-for="(emojiCon, emojiKey, eInd) in emojiIcon"
							v-if="eInd == eindex"
							:key="emojiKey"
							:label="emojiKey"
							:name="emojiKey"
						>
							<span
								@click="choose(emoItem)"
								:key="emoInd"
								v-for="(emoItem, emoInd) in emojiCon"
								v-html="emoItem.emoji"
							></span>
						</div>
					</div>
				</div>
				<div>
					<el-tooltip class="item" effect="dark" content="点击发送图片" placement="top-start">
						<i class="iconfont icon-tu_pian" @click="upload"></i>
					</el-tooltip>
					<input type="file" id="file" ref="file" @change="fileUpload" />
				</div>
				<div>
					<el-tooltip class="item" effect="dark" content="发送链接" placement="top-start">
						<i class="iconfont icon-lianjie" @click="sendLinkVisible = true"></i>
					</el-tooltip>
				</div>
				<div>
					<el-tooltip class="item" effect="dark" content="快捷回复列表" placement="top-start">
						<i class="iconfont icon-message" @click="quickReplyShow"></i>
					</el-tooltip>
				</div>
				<!-- <div>
					<el-tooltip class="item" effect="dark" content="发送订阅邀请" placement="top-start">
						<i class="iconfont icon-zhong" @click="subInvitation"></i>
					</el-tooltip>
				</div>-->
				<div>
					<el-tooltip class="item" effect="dark" content="邀请注册" placement="top-start">
						<i class="iconfont icon-huabanfuben" @click="regInvitation"></i>
					</el-tooltip>
				</div>
				<div>
					<el-tooltip class="item" effect="dark" content="选择发送小程序" placement="top-start">
						<i class="iconfont icon-tubiaozhizuomoban" @click="openMini"></i>
					</el-tooltip>
				</div>
			</div>
		</div>
		<div class="enter_box" @click="setFocus">
			<div id="quickLists" class="model" v-show="quickIsShow">
				<div
					:class="quickIndex==index?'Keywords active':'Keywords'"
					:key="index"
					v-for="(item,index) in quickMonitor"
					@click.stop="quickListSelected(item)"
				>
					<!-- <span style="Keywords1">{{item.keyWord}}</span> -->
					<el-tooltip :content="item.content" placement="bottom">
						<span>{{item.content}}</span>
					</el-tooltip>
				</div>
			</div>
			<!-- @blur="quickClose" -->
			<div
				id="charInput"
				@click="saveRangeLocal($event)"
				@focus="saveRangeLocal($event)"
				@input="saveRangeLocal($event)"
				class="charInput"
				contenteditable="true"
				@keyup="autoCompletion($event)"
			>
				<span v-if="assemblyType==='3'">离线用户不可发送消息</span>
			</div>
		</div>
		<el-button
			class="send"
			style="position: absolute;right: 10px;bottom: 15px;"
			@click="sendMessage"
			:disabled="assemblyType==='3'"
		>发送</el-button>
		<el-dialog title :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span style="font-size:18px;">
				是否结束与
				<span style="color:#5F93EC">{{cousultNickName}}</span> 的对话
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="closingSession" v-preventReClick>确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="链接"
			width="500px"
			:visible.sync="sendLinkVisible"
			:before-close="closeSendLinkVisible"
		>
			<div class="custom">
				<el-input placeholder="链接说明" style="width:100%" v-model="linkExplain"></el-input>
				<el-input placeholder="输入链接" v-model="sendLink" @keyup.enter.native="sendLinks">
					<template slot="prepend">https://</template>
				</el-input>
				<p style="border-bottom:1px dashed #ccc;margin-bottom:10px;"></p>
				<el-input
					placeholder="请输入自定义内容"
					style="width:100%;margin-bottom:10px;"
					v-model="item1.content"
					:key="index"
					v-for="(item1,index) in custom.customContent"
				>
					<el-button slot="append" icon="el-icon-delete" @click="deleteCustomContent(index)"></el-button>
				</el-input>
				<el-button
					icon="el-icon-plus"
					style="margin-top:10px;width:100%;"
					@click="addCustomContent"
				>添加一行自定义内容</el-button>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sendLinks">发 送</el-button>
			</span>
		</el-dialog>
		<!--结束对话弹窗-->
	</div>
</template>
<script>
let emojiData = require('@/assets/emoji/emoji.json')
import timer from '@/components/customer/talks/timer'
import showTime from '@/components/customer/talks/showTime'
import { getSendMessage } from '@/components/customer/talks/ViewModel'
import { FormatTimes } from '@/utils/FormatTime'
import { DateTime } from '@/utils/common'
import { getArea } from '@/utils/utils'
import preventReClick from '@/utils/preventReClick'
export default {
	name: 'chatBox',
	props: [],
	data() {
		return {
			emojiIcon: emojiData.icon,
			eindex: 0,
			input11: '',
			show4: false,
			sendMsg: 'ssfasdf',
			userConversationIds: 0,
			consultIds: 0,
			conversationLogs: 0,
			autoStarts: false,
			entryTimeMilliseconds: 0,
			dialogVisible: false,
			sendLinkVisible: false,
			sendLink: '', //连接
			linkExplain: '', //连接说明
			totalPage: 0,
			loading: false,
			paginations: {
				pageIndex: 0,
				pageSize: 30,
				total: 30
			},
			scrollHeight: 0,
			search: '',
			monitorKeyWord: '',
			quickMonitor: [],
			noMoreVisbile: false,
			custom: {
				customContent: []
			},
			Dialogues1: [],
			quickTimer: 0,
			quickIsShow: false,
			quickIndex: 0
		}
	},
	components: {
		timer,
		showTime
	},
	props: {
		ConsultId: {
			type: String,
			default: ''
		},
		UserConversationId: {
			type: String,
			default: ''
		},
		ConversationLogId: {
			type: Number,
			default: 0
		},
		Dialogues: {
			type: Array,
			default: () => []
		},
		entryTimeMillisecond: {
			type: Number,
			default: 0
		},
		Pagination: {
			type: Object,
			default: () => {
				var obj = new Object()
				obj.pageIndex = 0
				obj.pageSize = 30
				obj.total = 30
				return obj
			}
		},
		QuickQuery: {
			type: Array,
			default: () => []
		},
		cousultNickName: {
			type: String,
			default: ''
		},
		assemblyType: {
			type: String,
			default: '0'
		},
		create_time: {
			type: String,
			default: ''
		},
		TransferRemarks: {
			type: String,
			default: ''
		},
		kfDefaultHeadimg: {
			type: String,
			default: ''
		},
		consultDefaultHeadimg: {
			type: String,
			default: ''
		},
		consultNickName: {
			type: String,
			default: ''
		},
		kfNickName: {
			type: String,
			default: ''
		},
		accessType: {
			type: Number,
			default: 0
		},
		errSendMsgMessage: {
			type: String,
			default: '未知'
		}
	},
	mounted: function() {
		var testDiv = document.getElementById('testDiv')
		testDiv.addEventListener('scroll', this.handleScroll)
	},
	computed: {
		noMore() {
			return this.count >= 20
		}
	},
	watch: {
		entryTimeMillisecond: {
			deep: true,
			handler: function(val, oldVal) {
				if (val == 0) {
					this.autoStarts = false
				} else {
					this.autoStarts = true
				}
			}
		},
		UserConversationId: function(val) {
			this.userConversationIds = val
		},
		ConsultId: function(val) {
			let vm = this
			this.paginations = {
				pageIndex: 0,
				pageSize: 30,
				total: 30
			}
			this.consultIds = val
			if (this.Dialogues1 == undefined || this.Dialogues1.length == 0) {
				setTimeout(function() {
					if (vm.assemblyType === '3') {
						vm.getChatRecord()
					}
				}, 100)
			}
		},
		ConversationLogId: function(val) {
			this.ConversationLogs = val
		},
		Pagination: function(val) {
			if (val != undefined && Object.keys(val).length > 0) {
				this.paginations = val
				this.totalPage = val.total / val.pageSize
			}
		},
		search: function(val) {},

		Dialogues: {
			handler(newName, oldName) {
				this.Dialogues1 = newName
				setTimeout(function() {
					var ele = document.getElementById('testDiv')
					ele.scrollTop = ele.scrollHeight
				}, 200)
			},
			immediate: true,
			deep: true
		},
		accessType: function(val) {
			if (val == 2) {
				this.paginations.pageIndex = this.paginations.pageIndex + 1
				this.fetchData()
			}
		}
	},
	methods: {
		getTimeVal(time) {
			let dat = new DateTime()
			if (time == undefined) {
				return FormatTimes(this.create_time, 'hh:mm:ss')
			} else {
				let cont = FormatTimes(time, 'yyyy-MM-dd')
				let cont1 = dat.getDate()
				if (cont === cont1) {
					return FormatTimes(time, 'hh:mm:ss')
				} else {
					return FormatTimes(time, 'yyyy-MM-dd hh:mm:ss')
				}
			}
		},
		handleScroll(e) {
			var testDiv = document.getElementById('testDiv')
			var scrollTop = testDiv.scrollTop
			if (scrollTop == 0) {
				const { pageIndex, pageSize, total } = this.paginations
				if (pageIndex < total / pageSize && this.ConsultId != '') {
					this.loading = true
					this.paginations.pageIndex = this.paginations.pageIndex + 1
					this.fetchData()
					this.scrollHeight = testDiv.scrollHeight
					this.noMoreVisbile = false
				} else if (this.ConsultId != '') {
					this.noMoreVisbile = true
					this.loading = false
				}
			} else {
				this.loading = false
				this.noMoreVisbile = false
			}
		},
		fetchData() {
			let obj = new Object()
			obj.pagination = this.paginations
			obj.conversationLogId = this.ConversationLogId
			obj.ConsultId = this.ConsultId
			obj.content = this.input11
			obj.assemblyType = this.assemblyType
			this.$emit('GetChatRecord', obj, this.uploadLoading)
		},
		uploadLoading() {
			this.loading = false
			let height = this.scrollHeight
			setTimeout(function() {
				var testDiv = document.getElementById('testDiv')
				let top = testDiv.scrollHeight - height
				testDiv.scrollTop = top
			}, 100)
		},
		tab(index) {
			this.eindex = index
		},
		choose(data) {
			let inputNode = document.getElementById('charInput')
			let html = data.emoji
			let sel = window.getSelection()
			let range = this.inputRange
			let el = document.createElement('div')
			let frag = document.createDocumentFragment(),
				node,
				lastNode
			if (!inputNode) {
				return
			}
			if (!range) {
				inputNode.focus()
				range = window.getSelection().getRangeAt(0)
			}
			range.deleteContents()
			el.innerHTML = html

			while ((node = el.firstChild)) {
				lastNode = frag.appendChild(node)
			}
			range.insertNode(frag)
			if (lastNode) {
				range = range.cloneRange()
				range.setStartAfter(lastNode)
				range.collapse(true)
				sel.removeAllRanges()
				sel.addRange(range)
			}
			this.show4 = !this.show4
		},
		ResendMessage(val) {
			//重新发送
			this.$emit('ckResendMsg', val)
		},
		// 延时记录光标到位置
		chartFramRange(type) {
			try {
				if (type === 'click') {
					this.inputRange = window.getSelection().getRangeAt(0)
				}
				if (type === 'focus') {
					this.inputRange = window.getSelection().getRangeAt(0)
				}
			} catch (err) {
				console.log(type)
			}
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					this.inputRange = window.getSelection().getRangeAt(0)
					resolve(this.inputRange)
				}, 0)
			})
		},
		getQuickList(keyWord, e) {
			let text = document.getElementById('charInput').innerText
			let vm = this
			if (vm.quickTimer != 0) {
				clearTimeout(vm.quickTimer)
			}
			this.axios
				.get(
					'quickReply/GetFuzzyQuery',
					{
						params: { keyWord: keyWord }
					},
					{
						headers: {
							'Content-Type': 'application/json; charset=utf-8'
						}
					}
				)
				.then(function({ data }) {
					vm.quickMonitor = data
					if (data != undefined && data != null && data.length > 0) {
						vm.quickTimer = setTimeout(function() {
							vm.showAutoUI(e, text)
							vm.quickIsShow = true
						}, 0)
					} else {
						vm.quickIsShow = false
					}
				})
		},
		// 延时记录光标到位置
		saveRangeLocal(e) {
			let vm = this
			setTimeout(() => {
				let text = document.getElementById('charInput').innerText
				let index = text.indexOf('#')
				if (index > -1) {
					let keyArr = text.split('#')
					vm.monitorKeyWord = '#' + keyArr[keyArr.length - 1]
					if (e.keyCode != 108) {
						vm.getQuickList(vm.monitorKeyWord, e)
					}
				} else {
					vm.monitorKeyWord = ''
					vm.quickMonitor = []
					vm.quickIsShow = false
				}
			}, 500)
		},
		autoCompletion(e) {
			let vm = this

			if (e.keyCode == 1) {
			}
			// 监听上键与下键，拦截默认事件并阻止冒泡
			if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
				e.cancelBubble = true
				e.stopPropagation()
				e.preventDefault()
				e.returnValue = false
				let height = 0
				let scroll = document.getElementById('quickLists')
				if (vm.quickIsShow) {
					height = scroll.offsetHeight
				}
				// .children[0].
				var hScrollTop = scroll.scrollTop
				// if (hScrollTop < 10) {
				// 	hScrollTop = scroll.children[0].offsetHeight
				// }
				if (e.keyCode === 40) {
					if (vm.quickIndex < vm.quickMonitor.length - 1) {
						vm.quickIndex += 1
						// let heigs = scroll.children[vm.quickIndex].offsetHeight
						// scroll.scrollTo(0, vm.quickIndex * heigs - heigs / 2)
						vm.scrolls()
					}
				} else if (e.keyCode == 38) {
					if (vm.quickMonitor.length > 0 && vm.quickIndex > 0) {
						vm.quickIndex -= 1
						// let heigs = scroll.children[vm.quickIndex].offsetHeight
						// scroll.scrollTop = vm.quickIndex * heigs - heigs / 2
						vm.scrolls()
					}
				} else if (e.keyCode === 13) {
					if (vm.quickIsShow) {
						this.quickListSelected()
					} else {
						this.sendMessage()
					}
				}
				this.setFocus()
				return false
			}
			let text = document.getElementById('charInput').innerText
			let index = text.indexOf('#')
			if (index > -1) {
				let keyArr = text.split('#')
				vm.monitorKeyWord = '#' + keyArr[keyArr.length - 1]
				if (e.keyCode != 108) {
					//不等于回车的时候
					debugger
					vm.getQuickList(vm.monitorKeyWord, e)
				}
			} else {
				vm.monitorKeyWord = ''
				vm.quickMonitor = []
			}
		},
		quickListSelected(item) {
				debugger
			let vm = this
			 
			if(item==undefined){
				
				item = vm.quickMonitor[vm.quickIndex];
				debugger
			}
			var content =item.content;
			let text = document.getElementById('charInput').innerText
			text = text.replace(vm.monitorKeyWord, '').trim()
			text += content.trim()
			document.getElementById('charInput').innerText = text
			setTimeout(() => {
				vm.quickIsShow = false
				vm.quickMonitor = []
			}, 100)

				this.$emit('selectedReply', item)
		},
		scrolls() {
			let vm = this
			let scroll = document.getElementById('quickLists')
			let activeTop = scroll.children[vm.quickIndex].offsetTop
			let scrollOffTop = scroll.offsetTop
			// scroll.scrollTop = scroll.scrollTop + (activeTop - scrollOffTop)
			scroll.scrollTop = activeTop

			// var itemHeight = scroll.children[vm.quickIndex].offsetHeight // 元素高度
			// var wrapHeight = scroll.offsetHeight // 滚动区域容器高度
			// var index = scroll.children[vm.quickIndex].offsetHeight // 当前元素序号
			// var itemHeightTop = itemHeight * index // 当前元素距离容器顶部高度
			// var curScrollTop = scroll.scrollTop // 当前滚动条滚动距离
			// if (
			// 	itemHeightTop < curScrollTop ||
			// 	curScrollTop < itemHeightTop - wrapHeight
			// ) {
			// 	// document.documentElement.scrollTop = itemHeightTop // 滚动容器是body时有效
			// 	debugger
			// 	scroll.scrollTop = itemHeight
			// }
		},
		setFocus(el) {
			setTimeout(() => {
				el = document.getElementById('charInput')
				el.focus()
				var range = document.createRange()
				range.selectNodeContents(el)
				range.collapse(false)
				var sel = window.getSelection()
				//判断光标位置，如不需要可删除
				if (sel.anchorOffset != 0) {
					return
				}
				sel.removeAllRanges()
				sel.addRange(range)
			}, 400)
		},
		quickClose() {
			let vm = this
			setTimeout(() => {
				vm.quickIsShow = false
				vm.quickMonitor = []
			}, 300)
		},
		showAutoUI(e, text) {
			let doc = document.getElementById('quickLists')
			var strs = this.getSelectonCoords()
			doc.style.left = strs.left + 'px'
			doc.style.top = strs.top - doc.clientHeight + 'px'
		},
		/**
		 *获取光标的位置
		 */
		getPosition(element) {
			var cursorPos = 0
			if (document.selection) {
				//IE
				var selectRange = document.selection.createRange()
				selectRange.moveStart('character', -element.value.length)
				cursorPos = selectRange.text.length
			} else if (
				element.selectionStart ||
				element.selectionStart == '0'
			) {
				cursorPos = element.selectionStart
			}
			return cursorPos
		},
		getSelectonCoords() {
			var win = win || window
			var doc = win.document
			var sel = doc.selection,
				range,
				rects,
				rects
			var rect = 0
			var x = 0,
				y = 0
			if (sel) {
				if (sel.type != 'Control') {
					range = sel.createRange()
					range.collapse(true)
					x = range.boundingLeft
					y = range.boundingTop
				}
			} else if (win.getSelection) {
				sel = win.getSelection()
				if (sel.rangeCount) {
					range = sel.getRangeAt(0).cloneRange()
					if (range.getClientRects) {
						range.collapse(true)
						rects = range.getClientRects()
						if (rects.length > 0) {
							rect = rects[0]
						}
						// 光标在行首时，rect为undefined
						if (rect) {
							x = rect.left
							y = rect.top
						}
					}
					// Fall back to inserting a temporary element
					if ((x == 0 && y == 0) || rect === undefined) {
						var span = doc.createElement('span')
						if (span.getClientRects) {
							// Ensure span has dimensions and position by
							// adding a zero-width space character
							span.appendChild(doc.createTextNode('\u200b'))
							range.insertNode(span)
							rect = span.getClientRects()[0]
							x = rect.left
							y = rect.top
							var spanParent = span.parentNode
							spanParent.removeChild(span)

							// Glue any broken text nodes back together
							spanParent.normalize()
						}
					}
				}
			}
			return { left: x, top: y }
		},
		upload() {
			this.$refs.file.click()
			let file = event.target.files
			console.log(this.$refs.file)
		},
		fileUpload(event) {
			//上传文件
			let file = event.target.files
			let formData = new FormData()
			formData.append('category', 'settingPic')
			formData.append('file', file[0])
			this.$emit('UploadFile', formData)
		},
		sendMessage() {
			let inputNode = document.getElementById('charInput')
			var text = inputNode.textContent
			if (text == '' || text == undefined) {
				return
			}
			inputNode.innerHTML = ''
			var obj = new Object()
			var Arr = []
			Arr.push(
				getSendMessage(this.UserConversationId, this.ConsultId, 1, text)
			)
			obj.Receiver = this.ConsultId
			obj.conversationLogId = this.ConversationLogId
			obj.sendTime = new DateTime().Now()
			obj.dialogues = Arr
			this.$emit('Message', obj)
		},
		closingSession() {
			let vm = this
			this.$emit(
				'closingSession',
				vm.ConversationLogs,
				vm.UserConversationId,
				vm.ConsultId,
				this.closeVisible
			) //结束会话
		},
		closeVisible() {
			this.dialogVisible = false
		},
		transfer() {
			let vm = this
			var obj = new Object()
			obj.conversationLogId = vm.conversationLogs
			obj.userConversationIds = vm.userConversationIds
			obj.consultIds = vm.consultIds
			this.$emit('chatBoxTransfer', obj)
		},
		handleClose() {},
		chatBoxSearch() {
			if (
				this.ConversationLogId == null ||
				this.ConversationLogId == undefined ||
				this.ConversationLogId == 0
			) {
				this.$confirm('请先选中咨询人!', '提示', {
					confirmButtonText: '确定',
					type: 'warning'
				})
				return
			}
			this.loading = true
			this.paginations.pageIndex = 1
			let obj = new Object()
			obj.pagination = this.paginations
			obj.conversationLogId = this.ConversationLogId
			obj.ConsultId = this.ConsultId
			obj.content = this.input11
			this.$emit('SearchChatBox', obj, undefined) //this.uploadLoading
		},
		openMini() {
			this.$emit('openMiniDialog')
		},
		checkKeyWord(val) {
			console.log(val)
		},
		// outputKeySub(val) {
		// 	let vm = this
		// 	let text = document.getElementById('charInput').innerText
		// 	text = text.replace(vm.monitorKeyWord, '')
		// 	text += val
		// 	document.getElementById('charInput').innerText = text
		// 	vm.monitorKeyWord = ''
		// 	vm.quickMonitor = []
		// 	vm.quickIsShow = false
		// },
		quickReplyShow() {
			this.$emit('quickReplyShow')
		},
		sendLinks() {
			let vm = this
			if (vm.sendLink == undefined || vm.sendLink == '') {
				this.$message.error({ message: '链接不能为空' })
				return
			}

			let link = 'https://' + vm.sendLink
			var obj = new Object()
			var Arr = []
			if (vm.linkExplain != undefined && vm.linkExplain != '') {
				Arr.push(
					getSendMessage(
						vm.UserConversationId,
						vm.ConsultId,
						12,
						vm.linkExplain
					)
				)
			}
			Arr.push(
				getSendMessage(this.UserConversationId, this.ConsultId, 6, link)
			)
			if (vm.custom.customContent.length > 0) {
				Arr.push(
					getSendMessage(vm.UserConversationId, vm.ConsultId, 13, '')
				)
				Arr = Arr.concat(vm.custom.customContent)
			}
			obj.Receiver = this.ConsultId
			obj.conversationLogId = this.ConversationLogId
			obj.sendTime = new DateTime().Now()
			obj.dialogues = Arr
			this.$emit('Message', obj)
			vm.closeSendLinkVisible()
			vm.custom = {
				customContent: []
			}
			vm.linkExplain = ''
		},
		closeSendLinkVisible() {
			this.sendLinkVisible = false
			this.sendLink = ''
		},
		getChatRecord() {
			this.loading = true
			this.paginations.pageIndex = 1
			let obj = new Object()
			obj.pagination = this.paginations
			obj.conversationLogId = this.ConversationLogId
			obj.ConsultId = this.ConsultId
			obj.content = this.input11
			obj.assemblyType = this.assemblyType
			this.$emit('GetChatRecord', obj, this.uploadLoading)
		},
		subInvitation() {
			let vm = this
			var obj = new Object()
			var Arr = []
			obj.Receiver = vm.ConsultId
			obj.conversationLogId = vm.ConversationLogId
			obj.sendTime = new DateTime().Now()
			this.axios
				.get('SysSubMessage/getSysMessages', {
					params: { groupId: '298f3714-9345-4576-bfe3-9c92341ae4f8' }
				})
				.then(function({ data }) {
					if (data.result) {
						data.data.forEach(item => {
							let arrs = []
							if (item.tip != undefined && item.tip != null) {
								arrs.push(item.tip)
							}
							Arr.push(
								getSendMessage(
									vm.UserConversationId,
									vm.ConsultId,
									item.messageType,
									item.name,
									arrs
								)
							)
						})
						obj.dialogues = Arr
						vm.$emit('Message', obj)
					}
				})
		},
		regInvitation() {
			let vm = this
			var obj = new Object()
			var Arr = []
			obj.Receiver = vm.ConsultId
			obj.conversationLogId = vm.ConversationLogId
			obj.sendTime = new DateTime().Now()
			this.axios
				.get('SysSubMessage/getSysMessages', {
					params: { groupId: 'b73986f6-b735-437f-9c9f-869f51cc80c6' }
				})
				.then(function({ data }) {
					if (data.result) {
						data.data.forEach(item => {
							Arr.push(
								getSendMessage(
									vm.UserConversationId,
									vm.ConsultId,
									item.messageType,
									item.name
								)
							)
						})
						obj.dialogues = Arr
						vm.$emit('Message', obj)
					}
				})
		},
		addCustomContent() {
			let vm = this
			let obj = getSendMessage(
				vm.UserConversationId,
				vm.ConsultId,
				12,
				''
			)
			vm.custom.customContent.push(obj)
		},
		deleteCustomContent(index) {
			let vm = this
			vm.custom.customContent.splice(index, 1)
		},
		addressMonitoringShow(str) {
			let text = str
				.filter(d => d.messageType == 1)
				.map(d => d.content)
				.join('')
			let obj = getArea(text)
			if (obj.Province != '' && obj.City != '' && obj.Country != '') {
				return true
			} else {
				return false
			}
		},
		saveAddressMonitorting(str) {
			let text = str
				.filter(d => d.messageType == 1)
				.map(d => d.content)
				.join('')
			let obj = getArea(text)
			this.$emit('saveAddressMonitorting', obj)
		},
		emptyInputBox() {
			document.getElementById('charInput').innerText = ''
		}
	}
}
</script>
<style scoped>
img {
	width: 150px;
}
video {
	width: 150px;
}
.niming {
	color: #999;
	margin-bottom: 5px;
}
.custom .el-input {
	margin-bottom: 10px;
}
/** */
.remarks {
	border-top: 1px dashed #ddd;
	padding-top: 5px;
	position: relative;
	bottom: 0px;
	width: 90%;
	height: 40px;
}

/*answer会话*/
.flex-title {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}
.nickname {
	color: #bbb;
}
.flex-time span {
	color: #fe1c11;
}
.ended {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #f74b55;
	margin: 4px 0px 4px 4px;
}
.ended:hover {
	color: #fff;
}
.Transfer {
	display: inline-block;
	height: 25px;
	line-height: 25px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	margin: 4px;
}
.Transfer:hover {
	color: #fff;
}
.talk {
	padding: 10px 35px;
	height: 50%;

	overflow-y: auto;
	overflow-x: hidden;
	position: relative;
}
.search-box {
	line-height: 44px;
	border-bottom: 1px solid #ddd;
}
.search-box .el-input-group {
	width: 320px;
	margin-left: 20px;
}
.talk p {
	text-align: center;
	color: #bbb;
	line-height: 30px;
}
.container {
	overflow-x: hidden;
	overflow-y: auto;
}
/*滚动条样式*/
::-webkit-scrollbar {
	width: 8px;
}

::-webkit-scrollbar-track {
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 5px;
}
a:hover {
	color: #ff0000;
}
a {
	color: #409eff;
}
.talk_left {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 10px;
	min-width: 100px;
}
.talk_left .content {
	margin-left: 10px;
}
.talk_left .content img {
	max-width: 300px;
}
.text {
	max-width: 400px;
	padding: 15px;
	background-color: #dcedf9;
	border-radius: 5px;
	font-size: 14px;
	letter-spacing: 1px;
}
.text span {
	width: 100%;
	/* display: inline-block; */
	word-wrap: break-word;
	word-break: break-all;
	overflow: hidden;
}
.talk_left .text::after {
	position: absolute;
}
.talk_right {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	margin-bottom: 10px;
}
.talk_right .content {
	margin-right: 10px;
}
.talk_right .content img {
	max-width: 225px;
}

.heading {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}
.heading img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
.tool1 {
	border: 1px solid #ddd;
	height: 40px;
	line-height: 40px;
}
.tool {
	height: 40px;
	line-height: 40px;
	padding: 0;
	background-color: #fafafa;
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.tool i {
	font-size: 25px;
	margin-left: 20px;
	cursor: pointer;
	vertical-align: middle;
}
.charInput {
	padding: 5px 15px;
	/* min-height: 120px;
	*/
	max-height: 120px;
	outline: none;
	font-size: 20px;
	line-height: 30px;
	word-wrap: break-word;
	overflow: auto;
}
/*表情*/

.send {
	display: inline-block;
	height: 35px;
	line-height: 35px;
	padding: 0px 15px;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background-color: #409eff;
	float: right;
	margin: 4px;
	outline: none;
	border: none;
	cursor: pointer;
	margin-right: 20px;
}
.emoji_box {
	position: relative;
}
.emoji {
	position: absolute;
	background: #fff;
	width: 450px;
	height: 150px;
	border: 1px solid #ebeef5;
	padding: 12px;
	z-index: 2000;
	color: #606266;
	line-height: 1.4;
	text-align: justify;
	font-size: 14px;
	-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	word-break: break-all;
	bottom: 45px;
}
.emoji span {
	display: inline-block;
	width: 30px;
	height: 30px;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	font-style: normal;
	font-size: 20px;
}
.page {
	display: flex;
	bottom: 0;
	left: 0;
	width: 100%;
	padding-top: 5px;
	margin-top: 10px;
	border-top: 1px solid #e6e6e6;
}
.el-tabs__content {
	height: 130px;
	display: inline-block;
}
.page > div {
	-webkit-box-flex: 1;
	flex: 1;
}
#file {
	display: none;
}
.setting {
	font-size: 26px;
	cursor: pointer;
}
.close {
	font-size: 24px;
	cursor: pointer;
	color: #888;
}
.enter_box {
	position: relative;
	height: 120px;
	max-height: 120px;
}
#quickLists {
	position: fixed;
	width: 500px;
	height: 120px;
	/* left: 15px;
	top: 40px; */
	background-color: #fff;
	overflow-y: auto;
}
#quickLists::-webkit-scrollbar {
	width: 6px;
}
#quickLists .Keywords {
	line-height: 40px;
	background-color: #f7f7f7;
	margin-bottom: 5px;
	padding-left: 15px;
	white-space: nowrap;

	overflow: hidden;

	text-overflow: ellipsis;
}
#quickLists .Keywords .Keywords1 {
	width: 70px;
	display: inline-block;
}
#quickLists .Keywords:hover {
	background-color: #efefef;
}
#quickLists .active {
	background-color: #efefef;
}
.itemTime {
	margin-top: 3px;
	/* margin: 0px 0px; */
	/* display: inline-block; */
	text-align: right;
}
#rowText {
	text-align: left;
	color: black;
	max-width: 200px;
	height: auto;
	word-wrap: normal;
	word-break: break-all;
	line-height: 18px;
}
#errorImg:hover {
	cursor: pointer;
}
.addressMonitoring {
	font-size: 14px;
}
.addressMonitoring:hover {
	cursor: pointer;
	color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/chatBox.vue